/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PriceHistoryPoint
 */
export interface PriceHistoryPoint {
    /**
     * 
     * @type {Date}
     * @memberof PriceHistoryPoint
     */
    observedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof PriceHistoryPoint
     */
    nightlyCashCost: number;
    /**
     * 
     * @type {string}
     * @memberof PriceHistoryPoint
     */
    cashCurrency: string;
}

/**
 * Check if a given object implements the PriceHistoryPoint interface.
 */
export function instanceOfPriceHistoryPoint(value: object): value is PriceHistoryPoint {
    if (!('observedAt' in value) || value['observedAt'] === undefined) return false;
    if (!('nightlyCashCost' in value) || value['nightlyCashCost'] === undefined) return false;
    if (!('cashCurrency' in value) || value['cashCurrency'] === undefined) return false;
    return true;
}

export function PriceHistoryPointFromJSON(json: any): PriceHistoryPoint {
    return PriceHistoryPointFromJSONTyped(json, false);
}

export function PriceHistoryPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceHistoryPoint {
    if (json == null) {
        return json;
    }
    return {
        
        'observedAt': (new Date(json['observed_at'])),
        'nightlyCashCost': json['nightly_cash_cost'],
        'cashCurrency': json['cash_currency'],
    };
}

export function PriceHistoryPointToJSON(json: any): PriceHistoryPoint {
    return PriceHistoryPointToJSONTyped(json, false);
}

export function PriceHistoryPointToJSONTyped(value?: PriceHistoryPoint | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'observed_at': value['observedAt'].toISOString(),
        'nightly_cash_cost': value['nightlyCashCost'],
        'cash_currency': value['cashCurrency'],
    };
}

